import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import { getAgents } from "../../services/clients";
import AgentsTable from "../../components/Tables/AgentsTable";

export const Agents = () => {
  const { selectedClient } = useContext(AppContext);
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        setAgents(
          await getAgents(selectedClient.public_id ?? selectedClient.id)
        );
        console.log(agents);
      } catch (error) {
        console.error(error);
      }
    };

    console.log("!!! SELECTED CLIENT FROM AGENTS: ", selectedClient);
    if (selectedClient) {
      fetchAgents();
    }
    // eslint-disable-next-line
  }, [selectedClient]);
  return (
    <div>
      <h1>Agents</h1>
      <AgentsTable agents={agents} />
    </div>
  );
};

export default Agents;
